export default __webpack_public_path__ + "static/media/skovstykket-townhouse-4-rooms-07.2c8aa0b9.jpg";